import React from "react";

import { BookingDetails } from "./BookingDetails";
import { BookingHeader } from "./BookingHeader";

interface Props {
  booking: any;
  done: boolean;
  driver?: any;
  vehicle?: any;
}

export default function BookingCard({ booking, done, driver, vehicle }: Props) {
  return (
    <div
      className={`rounded-2xl border p-3 shadow-inner transition hover:border-primary/40 ${
        done
          ? "border-emerald-500/30 bg-emerald-500/10"
          : "border-white/10 bg-white/5"
      }`}
    >
      <BookingHeader booking={booking} driver={driver} vehicle={vehicle} />
      <BookingDetails booking={booking} driver={driver} vehicle={vehicle} />
    </div>
  );
}
